import React from 'react';
import copyToClipboard from 'copy-to-clipboard';
import styles from './index.less';
import message from '@src/components/common-message';

/**
 * 复制文本
 * @param {string} text - 复制文本, 返回值 true|false 代表是否复制成功过
 * @param {boolean} [autoDisplayUnsupportedAlert] - 在不支持复制的时候是否弹出提示, 设置 false 不进行相关操作, 提供该 API 为了让开发者可以自行不使用默认弹出提示
 * @param {boolean} [autoDisplaySupportedAlert] - 在支持复制的时候弹出提示, 设置 false 不进行相关操作, 提供该 API 为了让开发者可以自行不使用默认弹出提示
 * @param {string} [successPreText] - 成功时前置提示性文案, 默认: 您已经成功复制以下内容
 * @param {number} [successToastDuration] - 成功吐司弹出持续时间, 单位: 毫秒, 默认 2500
 * @param {string} [failPreText] - 失败时前置提示性文案, 默认: 由于您的设备不兼容, 请手动长按复制
 * @param {boolean} [isSupport] - 是否支持复制, 一般情况下不建议使用, 暴露这个 API 目的主要用于单元测试或 DEMO 使用
 * @returns {{isSupport, close}} - isSupport: 是否成功复制, close: 仅在 isSupport=false 时生效
 */
export default function copy(
  text,
  {
    autoDisplayUnsupportedAlert = true,
    autoDisplaySupportedAlert = true,
    successPreText = '您已经成功复制以下内容:',
    successToastDuration = 2500,
    failPreText = '由于您的设备不兼容, 请手动长按复制',
    isSupport = copyToClipboard(text)
  } = {}
) {
  copyToClipboard(text);
  if (isSupport) {
    autoDisplaySupportedAlert &&
      message.success(
        <div className={styles.toastText}>
          {successPreText}
          <br />
          <span className={styles.toastTextHighlight}>{text}</span>
        </div>,
        successToastDuration / 1000
      );
  } else {
    if (autoDisplayUnsupportedAlert) {
      const close = message.info(
        <div className={styles.text}>
          {failPreText}
          <span className={styles.highlight}>{text}</span>
        </div>
      );
      return { isSupport, close };
    }
  }
  return { isSupport };
}
